import { Payee } from '@root/api/ump-catalog-manager'
import { Amount } from '@root/api/ump-ewallet'

export enum TspPaymentStep {
  SERVICES_FORM = 'SERVICES_FORM',
  PAYMENT_FORM = 'PAYMENT_FORM',
  PAYMENT_OTP = 'PAYMENT_OTP',
  SERVICE_PAYMENT_ERROR = 'SERVICE_PAYMENT_ERROR',
  SBP_PAYMENT_RESULT = 'SBP_PAYMENT_RESULT',
  SBP_LOADING = 'SBP_LOADING',
  SERVICE_PAYMENT_NOT_MONEY = 'SBP_SERVICE_PAYMENT_NOT_MONEY',
  NOT_TCP = 'NOT_TCP',
}

export enum PaymentMethod {
  SBP = 'SBP',
  CARD = 'CARD',
  MTS_ACCOUNT = 'MTS_ACCOUNT',
}

type PaymentValues = {
  amountInfo: Amount
  serviceInfo: Payee | null
}

type CdekAgreementValues = {
  isPersonalDataAgreed?: false
  isMailingAgreed?: false
}

export interface PaymentFormValues extends PaymentValues, CdekAgreementValues {
  // steam
  promocode: string
  login: string
  price: string
  priceDollar: string

  // другие тсп
  phone: string
  email: string
  uid: string
  server: string
  uidPubg: string
  id: string
  zoneId: string
  playerId: string
  region: string

  // card
  cardNumber?: string
  expiryDate?: string
  cvc?: string
}

export enum ConfirmationType {
  OTP_SMS_CALLBACK = 'OTP_SMS_CALLBACK',
  OTP_PAYMENT_PAGE = 'OTP_PAYMENT_PAGE',
  FINISH_3DS = 'FINISH_3DS',
  FINISH_3DS2 = 'FINISH_3DS2',
}

export interface FetchQRStatus {
  processTime: string
  state: string
  stateQr: string
  qrcId: string
  serviceId: number
  amount: {
    base?: number
    fee?: number
    total?: number
    currency: string
  }
  paymentPurpose?: string
  recipientInfo: {
    account: string
    email: string
  }
  operationId: string
}

export enum PayStatusSBP {
  WAIT = 'RCVD',
  // NOT_FOUND = 10,
  ACCEPTED = 'ACWP',
  REJECTED = 'RJCT',
}

export enum Status {
  SUCCESS = 'Success',
  WAIT = 'Wait',
  FAIL = 'Fail',
}
